var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-7b13710c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "zoomist-container" };
var _hoisted_2 = { class: "zoomist-wrapper" };
var _hoisted_3 = { class: "zoomist-image" };
var _hoisted_4 = { class: "lightbox__image-container" };
var _hoisted_5 = { class: "lightbox__image-wrapper" };
var _hoisted_6 = ["src"];
import 'zoomist/css';
import { computed, nextTick, onMounted, watch } from 'vue';
import Zoomist from 'zoomist';
import { LightboxStore } from '@common/stores';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LightboxSingle',
    setup: function (__props) {
        var _this = this;
        var lightboxStore = computed(function () { return LightboxStore; });
        var hidden = computed(function () { return lightboxStore.value.singleLightboxHidden; });
        var image = computed(function () { return lightboxStore.value.singleLightboxImage; });
        var zIndex = computed(function () { return lightboxStore.value.zIndex; });
        var zoomist;
        watch(hidden, function () {
            if (!hidden.value) {
                document.body.style.overflowY = 'hidden';
            }
            else {
                document.body.style.overflowY = 'auto';
                zoomist.zoomTo(1);
            }
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nextTick()
                        // watch on key 'esc'
                    ];
                    case 1:
                        _a.sent();
                        // watch on key 'esc'
                        document.body.addEventListener('keyup', function (e) {
                            if (e.key === 'Escape') {
                                hide();
                            }
                        });
                        zoomist = new Zoomist('.zoomist-container', {
                            zoomRatio: 0.05,
                            maxScale: 5,
                            slider: false,
                            zoomer: false,
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        var hide = function () {
            lightboxStore.value.singleLightboxHide();
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{
                        'lightbox--show': !hidden.value
                    }, "lightbox"]),
                style: _normalizeStyle({
                    zIndex: zIndex.value
                })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: image.value,
                                        alt: "",
                                        class: "lightbox__image"
                                    }, null, 8, _hoisted_6)
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", {
                    class: "lightbox__closer",
                    onClick: hide
                }, [
                    _createVNode(_component_e_icon, {
                        class: "w-5 h-5",
                        icon: "close"
                    })
                ]),
                _createElementVNode("div", {
                    class: "lightbox__backdrop",
                    onClick: hide
                })
            ], 6));
        };
    }
});
